import { validate as isUUID } from 'uuid'
import { Button } from '@/components/ui/button'

import { useShallow } from 'zustand/react/shallow'
import { useTechnicianPageStore } from '../hooks/useTechnicianPageStore'
import { useTechnicianDocument } from '../hooks/useTechnicianDocument'
import { useCreateSessionEvent } from '../hooks/useCreateSessionEvent'
import { findSubPageIndex } from '@/pages/TechnicianPage/fns'

export const NextButton = ({ nextId }: { nextId?: string | null }) => {
  const { createSessionEvent } = useCreateSessionEvent()
  const { currentPage } = useTechnicianDocument()

  const setCurrentPage = useTechnicianPageStore(
    useShallow((state) => state.setCurrentPage),
  )
  const addVisitedPage = useTechnicianPageStore(
    useShallow((state) => state.addVisitedPage),
  )

  return (
    <Button
      onClick={() => {
        const currentPageId = currentPage?.subPageId || currentPage?.id

        if (currentPage && currentPageId) {
          addVisitedPage(currentPageId)

          if (isUUID(currentPageId)) {
            createSessionEvent({
              documentPageId: currentPage.id,
              subPageIndex: findSubPageIndex(currentPage),
              buttonLabel: 'Next',
            })
          }
        }

        if (nextId) {
          setCurrentPage(nextId)
        }
      }}
      disabled={!nextId}
      size="lg"
      className="rounded-full"
      data-testid="technician-mode-next-button"
    >
      Next
    </Button>
  )
}
